export const VisitorActionType = {
  POST_VISITOR_API: 'VISITOR.POST_VISITOR_API',
  POST_VISITOR_API_SUCCESS: 'VISITOR.POST_VISITOR_API_SUCCESS',
  POST_VISITOR_API_FAILURE: 'VISITOR.POST_VISITOR_API_FAILURE',
  UPDATE_VISITOR_INPUT: 'VISITOR.UPDATE_VISITOR_INPUT',
  UPDATE_TOKEN: 'VISITOR.UPDATE_TOKEN',
  UPDATE_PROGRESS: 'VISITOR.UPDATE_PROGRESS'
}
